import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import { NAVIGATION_BAR_HEIGHT } from '@/components/NavigationBar/constants'
import { TrainingBanner } from '@/features/resources/components/Banner'

import { logEvent } from '@/lib/gtm'

function Hero(): React.ReactElement {
  const { t } = useTranslation('training')
  return (
    <Flex
      as="section"
      id="hero"
      sx={{
        w: 'full',
        minH: {
          base: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.base})`,
          md: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.md})`,
        },
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        backgroundImage: 'url("/images/resources/form/hero-bg.svg")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: { base: '100% 10%', md: 'center' },
        backgroundSize: { base: 'auto 60%', md: '100% auto' },
        position: 'relative',
      }}
    >
      <TrainingBanner
        onClickDownload={() => {
          logEvent({
            ga: {
              category: 'PDPA Checklist',
              action: 'Click CTA',
            },
          })
        }}
        t={t}
      />
    </Flex>
  )
}

export default Hero
